import Divider from '@mui/material/Divider';
import PropTypes from 'prop-types';
import { memo } from 'react';
import _ from 'lodash';
import GlobalStyles from '@mui/material/GlobalStyles';
import WdNavHorizontalLayout1 from './horizontal/WdNavHorizontalLayout1';
import WdNavVerticalLayout1 from './vertical/WdNavVerticalLayout1';
import WdNavVerticalLayout2 from './vertical/WdNavVerticalLayout2';
import WdNavHorizontalCollapse from './horizontal/types/WdNavHorizontalCollapse';
import WdNavHorizontalGroup from './horizontal/types/WdNavHorizontalGroup';
import WdNavHorizontalItem from './horizontal/types/WdNavHorizontalItem';
import WdNavHorizontalLink from './horizontal/types/WdNavHorizontalLink';
import WdNavVerticalCollapse from './vertical/types/WdNavVerticalCollapse';
import WdNavVerticalGroup from './vertical/types/WdNavVerticalGroup';
import WdNavVerticalItem from './vertical/types/WdNavVerticalItem';
import WdNavVerticalLink from './vertical/types/WdNavVerticalLink';
import { registerComponent } from './WdNavItem';

const inputGlobalStyles = (
  <GlobalStyles
    styles={(theme) => ({
      '.popper-navigation-list': {
        '& .fuse-list-item': {
          padding: '8px 12px 8px 12px',
          height: 40,
          minHeight: 40,
          '& .fuse-list-item-text': {
            padding: '0 0 0 8px',
          },
        },
        '&.dense': {
          '& .fuse-list-item': {
            minHeight: 32,
            height: 32,
            '& .fuse-list-item-text': {
              padding: '0 0 0 8px',
            },
          },
        },
      },
    })}
  />
);

/*
Register Fuse Navigation Components
 */
registerComponent('vertical-group', WdNavVerticalGroup);
registerComponent('vertical-collapse', WdNavVerticalCollapse);
registerComponent('vertical-item', WdNavVerticalItem);
registerComponent('vertical-link', WdNavVerticalLink);
registerComponent('horizontal-group', WdNavHorizontalGroup);
registerComponent('horizontal-collapse', WdNavHorizontalCollapse);
registerComponent('horizontal-item', WdNavHorizontalItem);
registerComponent('horizontal-link', WdNavHorizontalLink);
registerComponent('vertical-divider', () => <Divider className="my-16" />);
registerComponent('horizontal-divider', () => <Divider className="my-16" />);

function WdNavigation(props) {
  const options = _.pick(props, [
    'navigation',
    'layout',
    'active',
    'dense',
    'className',
    'onItemClick',
    'firstLevel',
    'selectedId',
  ]);
  if (props.navigation.length > 0) {
    return (
      <>
        {inputGlobalStyles}
        {props.layout === 'horizontal' && <WdNavHorizontalLayout1 {...options} />}
        {props.layout === 'vertical' && <WdNavVerticalLayout1 {...options} />}
        {props.layout === 'vertical-2' && <WdNavVerticalLayout2 {...options} />}
      </>
    );
  }
  return null;
}

WdNavigation.propTypes = {
  navigation: PropTypes.array.isRequired,
};

WdNavigation.defaultProps = {
  layout: 'vertical',
};

export default memo(WdNavigation);
